import { useEffect } from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useHistory } from 'react-router-dom';
import { usePrevious } from '../../helpers/use-previous.js';
import { getSearchFromFilter, getInputFilters, getInputSort, getPage } from '@crossroads/shop-state/filter';

var sortValueToInput = function sortValueToInput(value) {
  var lastIndex = value.lastIndexOf("_");
  if (lastIndex < 0 || lastIndex + 1 >= value.length) {
    return null;
  }
  var code = value.slice(0, lastIndex);
  var order = value.slice(lastIndex + 1);
  return {
    code: code,
    order: order === "desc" ? "DESC" : "ASC"
  };
};
var getAvailableFilters = function getAvailableFilters(filters) {
  var buckets = filters.reduce(function (acc, curr) {
    if (curr.__typename === "ProductFilterBucket") {
      return [].concat(acc, [_extends({}, curr, {
        values: curr.values.sort(function (a, b) {
          return a.value.localeCompare(b.value);
        })
      })]);
    }
    return acc;
  }, []);
  var booleans = filters.reduce(function (acc, curr) {
    if (curr.__typename === "ProductFilterBoolean") {
      return [].concat(acc, [_extends({}, curr)]);
    }
    return acc;
  }, []);
  var prices = filters.reduce(function (acc, curr) {
    if (curr.__typename === "ProductFilterPrice") {
      return [].concat(acc, [curr]);
    }
    return acc;
  }, []);
  var ranges = filters.reduce(function (acc, curr) {
    if (curr.__typename === "ProductFilterRange") {
      return [].concat(acc, [curr]);
    }
    return acc;
  }, []);
  return {
    buckets: buckets,
    booleans: booleans,
    prices: prices,
    ranges: ranges
  };
};
var locationWithDefaults = function locationWithDefaults(location, pointsToPrice) {
  if (pointsToPrice === void 0) {
    pointsToPrice = function pointsToPrice(price) {
      return price;
    };
  }
  var productFilters = getInputFilters(location).reduce(function (acc, curr) {
    if (curr.code === "price") {
      var price = _extends({}, curr, {
        minValue: typeof curr.minValue === "number" ? Math.floor(pointsToPrice(curr.minValue)) : undefined,
        maxValue: typeof curr.maxValue === "number" ? Math.floor(pointsToPrice(curr.maxValue)) : undefined
      });
      return [].concat(acc, [price]);
    }
    return [].concat(acc, [curr]);
  }, []);
  var productSort = getInputSort(location);
  var page = getPage(location);
  return _extends({}, location, {
    search: getSearchFromFilter(productFilters, productSort, page)
  });
};
var useUpdateProductList = function useUpdateProductList(load, pointsToPrice) {
  if (pointsToPrice === void 0) {
    pointsToPrice = function pointsToPrice(price) {
      return price;
    };
  }
  var _useHistory = useHistory(),
    location = _useHistory.location;
  var prevLocation = usePrevious(location);
  useEffect(function () {
    if (prevLocation && location.search !== prevLocation.search) {
      load(locationWithDefaults(location, pointsToPrice));
    }
  }, [location, prevLocation]);
};

export { getAvailableFilters, locationWithDefaults, sortValueToInput, useUpdateProductList };
//# sourceMappingURL=helpers.js.map
